import React from 'react';

import { SvgIcon } from '@mui/material';

type IconProps = {
  color?: string;
  fontSize?: 'large' | 'medium' | 'small';
  htmlColor?: string;
};

export function EditIcon({ color = 'var(--color-gray-70)', fontSize = 'medium', htmlColor }: IconProps) {
  return (
    <SvgIcon
      fill='none'
      fontSize={fontSize}
      height='16'
      htmlColor={htmlColor}
      viewBox='0 0 16 16'
      width='16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.9597 2.0402C13.7578 1.8392 13.5182 1.68019 13.2545 1.57236C12.9908 1.46452 12.7084 1.40999 12.4236 1.41191C12.1387 1.41384 11.8571 1.47219 11.5949 1.58359C11.3327 1.69499 11.0952 1.85723 10.8961 2.06094L2.30376 10.6533L1.2549 14.745L5.34663 13.6956L13.939 5.10322C14.1427 4.90419 14.305 4.66675 14.4164 4.40462C14.5279 4.14249 14.5863 3.86087 14.5882 3.57604C14.5901 3.29121 14.5356 3.00882 14.4277 2.7452C14.3198 2.48159 14.1607 2.24197 13.9597 2.0402V2.0402Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M10.0981 3.03857L12.9614 5.90189'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M2.24262 10.8933L5.10873 13.7544'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </SvgIcon>
  );
}
